function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "gd-1",
  d: "M10.35,44.5c-4.47-7.73-4.47-17.27,0-25s12.72-12.5,21.65-12.5,17.18,4.77,21.65,12.5,4.47,17.27,0,25-12.72,12.5-21.65,12.5-17.18-4.77-21.65-12.5ZM25.75,42.16c0,1.3,1.05,2.34,2.34,2.34h7.81c1.3,0,2.34-1.05,2.34-2.34s-1.05-2.34-2.34-2.34h-.78v-8.59c0-1.3-1.05-2.34-2.34-2.34h-4.69c-1.3,0-2.34,1.05-2.34,2.34s1.05,2.34,2.34,2.34h2.34v6.25h-2.34c-1.3,0-2.34,1.05-2.34,2.34ZM28.87,22.62c0,1.73,1.4,3.12,3.13,3.12s3.13-1.4,3.13-3.12-1.4-3.12-3.13-3.12-3.13,1.4-3.13,3.12Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 64 64"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/gameDetails.a043134f.svg";
export { SvgComponent as ReactComponent };